import styled from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet, themeGetColor } from 'modules/v2/foundation/theme';
export const Container = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: ${pxToRem(1)};
  height: ${pxToRem(1)};
  min-height: min-content;
  opacity: 0;
  overflow: hidden;
  border: ${pxToRem(1)} dashed ${themeGet('colors.blue.500')};
  border-radius: ${themeGet('borderRadius.sm')};
  text-align: center;
  background-color: ${themeGetColor('blue.50', 0.7)};
  pointer-events: none;

  ${(props) => props.$isDragging &&
    `
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    overflow: visible;
    pointer-events: all;
    transition: opacity 0.1s ease-in-out;
    z-index: 1;
  `}
`;
export const StickyContent = styled.div `
  position: sticky;
  top: 0;
  padding: ${themeGet('spacing.xl')};
`;
export const Input = styled.input `
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
  -webkit-appareance: none;
`;
export const BadgeContainer = styled.div `
  position: relative;
  display: inline-block;
  padding: ${themeGet('spacing.2xl')};
  border-radius: ${themeGet('borderRadius.md')};
  margin-bottom: ${themeGet('spacing.md')};

  background-color: ${themeGet('colors.blue.50')};

  &:last-child {
    margin-bottom: 0;
  }
`;
